import api from './api';

export const dashboardService = {
  // Get consolidated dashboard stats from the real API endpoint
  async getStats() {
    try {
      const response = await api.get('/api/dashboard/stats');
      
      // Transform the backend response to match frontend expectations
      const backendData = response.data;
      
      const transformedData = {
        snippets: Number(backendData.totalSnippets) || 0,
        docs: 0, // Backend doesn't have documents, only snippets
        folders: Number(backendData.totalFolders) || 0,
        views: Number(backendData.totalViews) || 0,
        // Enhanced stats
        publicItems: Number(backendData.publicItems) || 0,
        privateItems: Number(backendData.privateItems) || 0,
        itemsThisWeek: Number(backendData.itemsThisWeek) || 0,
        itemsThisMonth: Number(backendData.itemsThisMonth) || 0,
        tokensUsed: Number(backendData.tokensUsed) || 0,
        storageUsed: String(backendData.storageUsedFormatted) || '0 B',
        realViews: Number(backendData.realViews) || 0,
        viewsThisWeek: Number(backendData.viewsThisWeek) || 0,
        viewsThisMonth: Number(backendData.viewsThisMonth) || 0
      };
      
      return transformedData;
    } catch (error) {
      console.error('❌ DashboardService: Error fetching stats:', error);
      // Return fallback data on error
      return {
        snippets: 0,
        docs: 0,
        folders: 0,
        views: 0,
        publicItems: 0,
        privateItems: 0,
        itemsThisWeek: 0,
        itemsThisMonth: 0,
        tokensUsed: 0,
        storageUsed: '0 B',
        realViews: 0,
        viewsThisWeek: 0,
        viewsThisMonth: 0
      };
    }
  },

  // Get recent activity
  async getRecentActivity() {
    try {
      const response = await api.get('/api/dashboard/recent-activity');
      return response.data;
    } catch (error) {
      console.error('❌ DashboardService: Error fetching recent activity:', error);
      // Return empty array on error
      return [];
    }
  },

  // Get favorite folders
  async getFavoriteFolders() {
    try {
      const response = await api.get('/api/dashboard/favorite-folders');
      return response.data;
    } catch (error) {
      console.error('❌ DashboardService: Error fetching favorite folders:', error);
      // Return empty array on error
      return [];
    }
  }
};

export default dashboardService;
